export enum FileType {
    MAIL_SHOT = 'MAIL_SHOT',
    SUB_BRAND = 'SUB_BRAND',
    NOTIFICATIONS = 'NOTIFICATIONS'
}

